<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- <vx-card> -->
    <div v-else class="w-full">
      <vx-card>
        <div class="vx-row mb-3 row-align">
          <div class="list-heading">
            {{ $t("accounting.label.openingbalances") }}
          </div>
          <div class="vx-col w-full md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{
                $t("accounting.label.entity")
              }}</small>
              <v-select
                label="name"
                v-if="OfficesList"
                v-model="selectedOffice"
                :options="OfficesList"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(obj) => obj.id"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full font-semibold"
              ></v-select>
            </div>
          </div>
          <div class="vx-col w-full md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{
                $t("accounting.label.currency")
              }}</small>
              <v-select
                label="name"
                v-if="CurrencyData.selectedCurrencyOptions"
                v-model="selectedCurrency"
                :options="CurrencyData.selectedCurrencyOptions"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(obj) => obj.code"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full font-semibold"
              ></v-select>
            </div>
          </div>
          <vs-button
            icon-pack="feather"
            icon="icon-search"
            :disabled="isSearchDisabled"
            @click="handleSearch"
            size="small"
            >{{ $t("accounting.label.search") }}</vs-button
          >
        </div>
        <div v-if="OpeningBalancesList" class="vx-row mb-3 row-align">
          <div class="vx-col w-full md:w-1/3 sm:w-full xs:w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{
                $t("accounting.label.dateofopeningbalances")
              }}</small>
              <datepicker
                placeholder="Select Date"
                v-model="transactionDate"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full"
              />
            </div>
          </div>
          <div class="vx-col w-full md:w-1/3 sm:w-full xs:w-full">
            <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('accounting.label.openingbalancescontra')"
                >
            <vs-input
              :label="$t('accounting.label.openingbalancescontra')"
              class="w-full font-semibold"
              disabled
              v-model="contraAccount"
            />
            <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <vs-table v-if="OpeningBalancesList" :data="orderedOpeningBalances">
          <template slot="thead">
            <vs-th>{{ $t("accounting.label.type") }}</vs-th>
            <vs-th>{{ $t("accounting.label.glcode") }}</vs-th>
            <vs-th>{{ $t("accounting.label.account") }}</vs-th>
            <vs-th
              >{{ $t("accounting.label.debit")
              }} :<span class="ml-2">{{ debitSum }}</span></vs-th
            >
            <vs-th
              >{{ $t("accounting.label.credit")
              }} :<span class="ml-2">{{ creditSum }}</span></vs-th
            >
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="data" v-for="(accounts, index) in data">
              <vs-td :data="accounts.glAccountType.value">{{
                accounts.glAccountType.value
              }}</vs-td>
              <vs-td :data="accounts.glAccountCode">{{
                accounts.glAccountCode
              }}</vs-td>
              <vs-td :data="accounts.glAccountName">{{
                accounts.glAccountName
              }}</vs-td>
              <vs-td>
                <vs-input
                  type="number"
                  v-model="accounts.debitAmount"
                  class="w-full mb-2 font-semibold"
                  :disabled="!!accounts.creditAmount"
                  @input="
                    updateDebit(accounts.glAccountId, accounts.debitAmount)
                  "
                />
              </vs-td>
              <vs-td>
                <vs-input
                  type="number"
                  v-model="accounts.creditAmount"
                  class="w-full mb-2 font-semibold"
                  :disabled="!!accounts.debitAmount"
                  @input="
                    updateCredit(accounts.glAccountId, accounts.creditAmount)
                  "
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div v-if="OpeningBalancesList" class="vx-row center mb-5">
          <div class="vx-col w-full">
            <!-- <vs-button
              color="primary"
              type="border"
              class="mb-2 footerButton-cancel"
              @click="$router.push('/closing_entries')"
              >{{ $t("accounting.label.cancel") }}</vs-button
            > -->
            <vs-button
              class="mr-3 mb-2 footerButton-next"
              @click="handleSave"
              >{{ $t("accounting.label.save") }}</vs-button
            >
          </div>
        </div>
      </vx-card>
    </div>
    <!-- </vx-card> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      selectedOffice: "",
      selectedCurrency: "",
      toDate: "",
      contraAccount: "",
      transactionDate: moment().format("DD MMMM YYYY"),
      debits: [],
      credits: [],
    };
  },
  components: { AtomSpinner, vSelect, Datepicker },
  computed: {
    ...mapState({
      OfficesList: (state) => state.accounting.officesList,
      CurrencyData: (state) => state.accounting.currencyData,
      OpeningBalancesList: (state) => state.accounting.openingBalances,
      TransactionId: (state) => state.accounting.reverseTransactionId,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    isSearchDisabled() {
      return !(this.selectedOffice && this.selectedCurrency);
    },
    debitSum() {
      return this.orderedOpeningBalances
        .reduce((sum, accounts) => {
          return sum + (parseFloat(accounts.debitAmount) || 0);
        }, 0)
        .toFixed(2);
    },
    creditSum() {
      return this.orderedOpeningBalances
        .reduce((sum, accounts) => {
          return sum + (parseFloat(accounts.creditAmount) || 0);
        }, 0)
        .toFixed(2);
    },
    orderedOpeningBalances() {
      return [].concat(
        this.OpeningBalancesList &&
          this.OpeningBalancesList.assetAccountOpeningBalances
          ? this.OpeningBalancesList.assetAccountOpeningBalances
          : [],
        this.OpeningBalancesList &&
          this.OpeningBalancesList.liabityAccountOpeningBalances
          ? this.OpeningBalancesList.liabityAccountOpeningBalances
          : [],
        this.OpeningBalancesList &&
          this.OpeningBalancesList.incomeAccountOpeningBalances
          ? this.OpeningBalancesList.incomeAccountOpeningBalances
          : [],
        this.OpeningBalancesList &&
          this.OpeningBalancesList.expenseAccountOpeningBalances
          ? this.OpeningBalancesList.expenseAccountOpeningBalances
          : [],
        this.OpeningBalancesList &&
          this.OpeningBalancesList.equityAccountOpeningBalances
          ? this.OpeningBalancesList.equityAccountOpeningBalances
          : []
      );
    },
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    updateDebit(glAccountId, debitAmount) {
      let account = this.debits.find(
        (item) => item.glAccountId === glAccountId
      );
      if (account) {
        account.amount = debitAmount;
      } else {
        this.debits.push({ glAccountId, amount: debitAmount });
      }
    },
    updateCredit(glAccountId, creditAmount) {
      let account = this.credits.find(
        (item) => item.glAccountId === glAccountId
      );
      if (account) {
        account.amount = creditAmount;
      } else {
        this.credits.push({ glAccountId, amount: creditAmount });
      }
    },
    async getOfficeList() {
      try {
        this.$store.dispatch("accounting/getOfficesListAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCurrencyDataMethod() {
      try {
        this.$store.dispatch("accounting/getCurrencyDataAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async handleSearch() {
      const payload = {
        office: this.selectedOffice,
        currencyCode: this.selectedCurrency,
      };
      try {
        await this.$store.dispatch(
          "accounting/getOpeningBalancesAction",
          payload
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.contraAccount = `${this.OpeningBalancesList.contraAccount.name} (${this.OpeningBalancesList.contraAccount.glCode})`;
    },
    async handleSave() {
      const payload = {
        currencyCode: this.selectedCurrency,
        officeId: this.selectedOffice,
        credits: this.credits,
        debits: this.debits,
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        transactionDate: this.transactionDate,
      };
      try {
        await this.$store.dispatch(
          "accounting/saveOpeningBalancesAction",
          payload
        );
        this.$router.push({
          name: "View Transaction",
          params: { id: this.TransactionId.transactionId },
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  watch: {},
  async mounted() {
    await this.$store.dispatch('accounting/clearOpeningBalances');
    this.getOfficeList();
    this.getCurrencyDataMethod();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.header-dropdown1 {
  min-width: 200px !important;
}
.row-align {
  align-items: baseline;
}
</style>
